$(document).ready(function() {
    // Open the modal specified in data-modal
    $(".open-modal-cta").click(function() {
        var modalId = $(this).data("modal");
        $(modalId).addClass("show");
        $("html").addClass("hidescroll");
    });

    // Close modal when clicking close button
    $(".modal-close").click(function() {
        $(this).closest(".modal-custom").removeClass("show");
        $("html").removeClass("hidescroll");
    });

    // Close modal when clicking outside the modal box
    $(".modal-custom").click(function(e) {
        if ($(e.target).is(".modal-custom")) {
            $(this).removeClass("show"); 
            $("html").removeClass("hidescroll");
        }
    });
});




